import { gql } from '@apollo/client';

export const EXPORT_FUNDER_ACTIVITIES = gql`
  query ExportFunderActivities($input: ExportArgs!) {
    activities: exportFunderActivities(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id

          interventionIds
          interventionNames
          interventionSubjects
          interventionFocusSubjects
          interventionGrades
          interventionStartDate
          interventionEndDate

          attendanceRate
          actualDuration
          attachment
          attendeeType
          class
          description
          endDate
          grade
          group
          interventionName
          name
          numberOfAttendees
          numberOfSessions
          numberOfActualSessions
          occurence
          plannedDuration
          sessionDuration
          startDate
          year
          audienceSize {
            name
          }
          audienceType {
            name
          }
          grades {
            name
          }
          groupInstitutions {
            name
          }
          groupCohorts {
            name
          }
          frequency {
            name
          }
          frequencyType {
            name
          }
          institutions {
            name
          }
          interfaceType {
            name
          }
          inputTypes {
            name
          }
          plannedAttendees
          captureType
          tagNames
          institutionCount
          programmeNames
          programmeIds
          attendanceRate
          serviceProviderNames
          serviceProviderIds
          serviceProviders {
            name
          }
          sessions {
            id
            name
            description
            plannedDuration
            actualDuration
            plannedDate
            actualDate
            institutions {
              id
              name
              emisNumber
            }
            sessionAttendees {
              id
              primaryInstitution {
                id
                name
              }
            }
            sessionStatus
            additionalNotes
          }
          sessionAttendees {
            name
          }
          stakeholderRole {
            name
          }
          subject {
            name
          }
          targetAudiences {
            name
          }
          targetGroup {
            name
          }
          topicsCovered
          type {
            name
          }
          tags {
            name
          }
          interventions {
            id
            name
            fromDate
            toDate
            class {
              id
              name
            }
            gradeValues
            focusSubjectNames
            programme {
              id
              name
            }
            institutions {
              id
              emisNumber
              name
            }
            subjects {
              id
              name
            }
            treatmentGroups {
              id
              primaryInstitution {
                id
              }
              institutions {
                id
              }
              type {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
